import { render, staticRenderFns } from "./ListPermisoGuardia.vue?vue&type=template&id=0eb1302e&"
import script from "./ListPermisoGuardia.vue?vue&type=script&lang=js&"
export * from "./ListPermisoGuardia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports